import { createActions, createReducer } from "reduxsauce";
import Immutable from "seamless-immutable";

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  updateFeedRequest: ["resolve"],
  updateFeedSuccess: ["payload"],
  updateFeedFailure: ["error"],

  updateDetailRequest: ["data", "resolve"],
  updateDetailSuccess: ["payload"],
  updateDetailFailure: ["error"],

  submitRatingRequest: ["data", "resolve"],
  submitRatingSuccess: ["payload"],
  submitRatingFailure: ["error"],

  exploreProjectsRequest: ["resolve"],
  exploreProjectsSuccess: ["payload"],
  exploreProjectsFailure: ["error"],

  projectDetailRequest: ["data"],
  projectDetailSuccess: ["payload"],
  projectDetailFailure: ["error"],

  projectLeaderRequest: ["data"],
  projectLeaderSuccess: ["payload"],
  projectLeaderFailure: ["error"],

  projectResourcesRequest: ["data"],
  projectResourcesSuccess: ["payload"],
  projectResourcesFailure: ["error"],

  projectMembersRequest: ["data"],
  projectMembersSuccess: ["payload"],
  projectMembersFailure: ["error"],

  joinProjectRequest: ["data"],
  joinProjectSuccess: ["payload"],
  joinProjectFailure: ["error"],

  getJoinProjectsRequest: ["data"],
  getJoinProjectsSuccess: ["payload"],
  getJoinProjectsFailure: ["error"],

  getUserProjectsRequest: ["data", "resolve"],
  getUserProjectsSuccess: ["payload"],
  getUserProjectsFailure: ["error"],

  createProjectRequest: ["data"],
  createProjectSuccess: ["payload"],
  createProjectFailure: ["error"],

  getResourcesRequest: ["data"],
  getResourcesSuccess: ["payload"],
  getResourcesFailure: ["error"],

  addResourcesRequest: ["data", "resolve"],
  addResourcesSuccess: ["payload"],
  addResourcesFailure: ["error"],

  updateProjectDetailsRequest: ["data", "resolve"],
  updateProjectDetailsSuccess: ["payload"],
  updateProjectDetailsFailure: ["error"],

  deleteProjectRequest: ["data", "resolve"],
  deleteProjectSuccess: ["payload"],
  deleteProjectFailure: ["error"],

  getCommentsRequest: ["data", "resolve"],
  getCommentsSuccess: ["payload"],
  getCommentsFailure: ["error"],

  postCommentRequest: ["data", "resolve"],
  postCommentSuccess: ["payload"],
  postCommentFailure: ["error"],

  getProjectImagesRequest: ["data", "resolve"],
  getProjectImagesSuccess: ["payload"],
  getProjectImagesFailure: ["error"],

  addProjectImageRequest: ["data", "resolve"],
  addProjectImageSuccess: ["payload"],
  addProjectImageFailure: ["error"],

  deleteProjectImageRequest: ["data", "resolve"],
  deleteProjectImageSuccess: ["payload"],
  deleteProjectImageFailure: ["error"],

  updateProjectIconRequest: ["data", "resolve"],
  updateProjectIconSuccess: ["payload"],
  updateProjectIconFailure: ["error"],

  updateProjectAvatarRequest: ["data", "resolve"],
  updateProjectAvatarSuccess: ["payload"],
  updateProjectAvatarFailure: ["error"],

  createProjectUpdateRequest: ["data", "resolve"],
  createProjectUpdateSuccess: ["payload"],
  createProjectUpdateFailure: ["error"],

  getProjectUpdatesRequest: ["data", "resolve"],
  getProjectUpdatesSuccess: ["payload"],
  getProjectUpdatesFailure: ["error"],

  deleteProjectUpdateRequest: ["data", "resolve"],
  deleteProjectUpdateSuccess: ["payload"],
  deleteProjectUpdateFailure: ["error"],

  saveProjectRequest: ["data", "resolve"],
  saveProjectSuccess: ["payload"],
  saveProjectFailure: ["error"],
});

export const ProjectTypes = Types;
export default Creators;

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  fetching: false,
  error: null,
  updateFeed: [], // The public project updates
  exploreProjects: [], // The publicly explorable projects
  projectDetail: [], // The detail of the current projects
  projectLeader: [], // The project owner piblic details
  projectResources: [], // The current projects links/resources
  userProjects: [],
  resources: [],
  createdProject: {},
  projectToDelete: null,
  comments: [],
  projectImages: [],
  projectUpdates: [],
  updateDetail: {},

  // ==== NOT USED ==== //
  projectMembers: [], // The current project members
  projectJoinRequests: []
});

/* ------------- Reducers ------------- */

export const updateFeedRequest = (state, action) => {
  return { ...state, fetching: true };
};
export const updateFeedSuccess = (state, { payload }) => {
  return { ...state, fetching: false, error: null, updateFeed: payload };
};
export const updateFeedFailure = (state, { error }) => {
  return { ...state, fetching: false, error: error };
};

export const updateDetailRequest = (state, action) => {
  return { ...state };
};
export const updateDetailSuccess = (state, { payload }) => {
  return { ...state, fetching: false, error: null, updateDetail: payload };
};
export const updateDetailFailure = (state, { error }) => {
  return { ...state, fetching: false, error: error };
};

export const exploreProjectsRequest = (state, action) => {
  return { ...state, fetching: true };
};
export const exploreProjectsSuccess = (state, { payload }) => {
  return { ...state, fetching: false, error: null, exploreProjects: payload };
};
export const exploreProjectsFailure = (state, { error }) => {
  return { ...state, fetching: false, error: error };
};
export const projectDetailRequest = (state, action) => {
  return { ...state, fetching: true };
};
export const projectDetailSuccess = (state, { payload }) => {
  return { ...state, fetching: false, error: null, projectDetail: payload };
};
export const projectDetailFailure = (state, { error }) => {
  return { ...state, fetching: false, error: error };
};
export const projectLeaderRequest = (state, action) => {
  return { ...state, fetching: true };
};
export const projectLeaderSuccess = (state, { payload }) => {
  return { ...state, fetching: false, error: null, projectLeader: payload };
};
export const projectLeaderFailure = (state, { error }) => {
  return { ...state, fetching: false, error: error };
};
export const projectResourcesRequest = (state, action) => {
  return { ...state, fetching: true };
};
export const projectResourcesSuccess = (state, { payload }) => {
  return { ...state, fetching: false, error: null, projectResources: payload };
};
export const projectResourcesFailure = (state, { error }) => {
  return { ...state, fetching: false, error: error };
};
export const projectMembersRequest = (state, action) => {
  return { ...state, fetching: true };
};
export const projectMembersSuccess = (state, { payload }) => {
  return {
    ...state,
    fetching: false,
    error: null,
    projectMembers: [...state.projectMembers, payload]
  };
};

export const projectMembersFailure = (state, { error }) => {
  return { ...state, fetching: false, error: error };
};
export const joinProjectRequest = (state, action) => {
  return { ...state, fetching: true };
};
export const joinProjectSuccess = (state, { payload }) => {
  return {
    ...state,
    fetching: false,
    error: null,
    projectJoinRequests: payload
  };
};
export const joinProjectFailure = (state, { error }) => {
  return { ...state, fetching: false, error: error };
};
export const getJoinProjectsRequest = (state, action) => {
  return { ...state, fetching: true };
};
export const getJoinProjectsSuccess = (state, { payload }) => {
  return {
    ...state,
    fetching: false,
    error: null,
    projectJoinRequests: payload
  };
};
export const getJoinProjectsFailure = (state, { error }) => {
  return { ...state, fetching: false, error: error };
};
export const getUserProjectsRequest = (state, action) => {
  return { ...state, fetching: true };
};
export const getUserProjectsSuccess = (state, { payload }) => {
  return { ...state, fetching: false, error: null, userProjects: payload };
};
export const getUserProjectsFailure = (state, { error }) => {
  return { ...state, fetching: false, error: error };
};
export const createProjectRequest = (state, action) => {
  return { ...state, fetching: true };
};
export const createProjectSuccess = (state, { payload }) => {
  return {
    ...state,
    fetching: false,
    error: null,
    userProjects: [payload],
    createdProject: payload
  };
};

export const createProjectFailure = (state, { error }) => {
  return { ...state, fetching: false, error: error };
};
export const getResourcesRequest = (state, action) => {
  return { ...state, fetching: true };
};
export const getResourcesSuccess = (state, { payload }) => {
  return { ...state, fetching: false, error: null, resources: payload };
};
export const getResourcesFailure = (state, { error }) => {
  return { ...state, fetching: false, error: error };
};
export const addResourcesRequest = (state, action) => {
  return { ...state, fetching: true };
};
export const addResourcesSuccess = (state, { payload }) => {
  return { ...state, fetching: false, error: null, projectResources: payload };
};
export const addResourcesFailure = (state, { error }) => {
  return { ...state, fetching: false, error: error };
};
export const deleteProjectRequest = state => {
  return { ...state, fetching: true };
};

export const deleteProjectSuccess = (state, { payload }) => {
  return { ...state, fetching: false, error: null, userProjects: payload };
};

export const deleteProjectFailure = (state, { error }) => {
  return { ...state, fetching: false, error: error };
};
export const updateProjectDetailsRequest = state => {
  return { ...state, fetching: true };
};
export const updateProjectDetailsSuccess = (state, { payload }) => {
  return { ...state, fetching: false, error: null, projectDetail: payload };
};
export const updateProjectDetailsFailure = (state, { error }) => {
  return { ...state, fetching: false, error: error };
};
export const getCommentsRequest = state => {
  return { ...state, fetching: true };
};

export const getCommentsSuccess = (state, { payload }) => {
  return { ...state, fetching: false, error: null, comments: payload };
};

export const getCommentsFailure = (state, { error }) => {
  return { ...state, fetching: false, error: error };
};
export const postCommentRequest = state => {
  return { ...state, fetching: true };
};

export const postCommentSuccess = (state, { payload }) => {
  return {
    ...state,
    fetching: false,
    error: null,
    comments: [payload, ...state.comments]
  };
};

export const postCommentFailure = (state, { error }) => {
  return { ...state, fetching: false, error: error };
};

export const getProjectImagesRequest = state => {
  return { ...state, fetching: true };
};

export const getProjectImagesSuccess = (state, { payload }) => {
  return { ...state, fetching: false, error: null, projectImages: payload };
};

export const getProjectImagesFailure = (state, { error }) => {
  return { ...state, fetching: false, error: error };
};

export const addProjectImageRequest = state => {
  return { ...state, fetching: true };
};

export const addProjectImageSuccess = (state, { payload }) => {
  return {
    ...state,
    fetching: false,
    error: null,
    projectImages: [...state.projectImages, payload]
  };
};

export const addProjectImageFailure = (state, { error }) => {
  return { ...state, fetching: false, error: error };
};

export const deleteProjectImageRequest = state => {
  return { ...state, fetching: true };
};

export const deleteProjectImageSuccess = (state, { payload }) => {
  return {
    ...state,
    fetching: false,
    error: null,
    projectImages: payload
  };
};

export const deleteProjectImageFailure = (state, { error }) => {
  return { ...state, fetching: false, error: error };
};

export const updateProjectIconRequest = state => {
  return { ...state, fetching: true };
};
export const updateProjectIconSuccess = (state, { payload }) => {
  return { ...state, fetching: false, error: null, projectDetail: payload };
};
export const updateProjectIconFailure = (state, { error }) => {
  return { ...state, fetching: false, error: error };
};

export const updateProjectAvatarRequest = state => {
  return { ...state, fetching: true };
};
export const updateProjectAvatarSuccess = (state, { payload }) => {
  return { ...state, fetching: false, error: null, projectDetail: payload };
};
export const updateProjectAvatarFailure = (state, { error }) => {
  return { ...state, fetching: false, error: error };
};

export const createProjectUpdateRequest = state => {
  return { ...state, fetching: true };
};
export const createProjectUpdateSuccess = (state, { payload }) => {
  return {
    ...state,
    fetching: false,
    error: null,
    projectUpdates: payload
  };
};
export const createProjectUpdateFailure = (state, { error }) => {
  return { ...state, fetching: false, error: error };
};
export const getProjectUpdatesRequest = state => {
  return { ...state, fetching: true };
};
export const getProjectUpdatesSuccess = (state, { payload }) => {
  return {
    ...state,
    fetching: false,
    error: null,
    projectUpdates: [...payload.reverse()]
  };
};

export const getProjectUpdatesFailure = (state, { error }) => {
  return { ...state, fetching: false, error: error };
};

export const deleteProjectUpdateRequest = state => {
  return { ...state, fetching: true };
};
export const deleteProjectUpdateSuccess = (state, { payload }) => {
  return {
    ...state,
    fetching: false,
    error: null,
    projectUpdates: [...payload]
  };
};

export const deleteProjectUpdateFailure = (state, { error }) => {
  return { ...state, fetching: false, error: error };
};

export const saveProjectRequest = state => {
  return { ...state, fetching: true };
};
export const saveProjectSuccess = (state, { payload }) => {
  return {
    ...state,
    fetching: false,
    error: null,
    projectDetail: payload
  };
};

export const saveProjectFailure = (state, { error }) => {
  return { ...state, fetching: false, error: error };
};

export const submitRatingRequest = (state, action) => {
  return { ...state, fetching: true };
};
export const submitRatingSuccess = (state, { payload }) => {
  return { ...state, updateDetail: payload };
};
export const submitRatingFailure = (state, { error }) => {
  return { ...state };
};

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.UPDATE_FEED_REQUEST]: updateFeedRequest,
  [Types.UPDATE_FEED_SUCCESS]: updateFeedSuccess,
  [Types.UPDATE_FEED_FAILURE]: updateFeedFailure,

  [Types.UPDATE_DETAIL_REQUEST]: updateDetailRequest,
  [Types.UPDATE_DETAIL_SUCCESS]: updateDetailSuccess,
  [Types.UPDATE_DETAIL_FAILURE]: updateDetailFailure,

  [Types.EXPLORE_PROJECTS_REQUEST]: exploreProjectsRequest,
  [Types.EXPLORE_PROJECTS_SUCCESS]: exploreProjectsSuccess,
  [Types.EXPLORE_PROJECTS_FAILURE]: exploreProjectsFailure,

  [Types.PROJECT_DETAIL_REQUEST]: projectDetailRequest,
  [Types.PROJECT_DETAIL_SUCCESS]: projectDetailSuccess,
  [Types.PROJECT_DETAIL_FAILURE]: projectDetailFailure,

  [Types.PROJECT_LEADER_REQUEST]: projectLeaderRequest,
  [Types.PROJECT_LEADER_SUCCESS]: projectLeaderSuccess,
  [Types.PROJECT_LEADER_FAILURE]: projectLeaderFailure,

  [Types.PROJECT_RESOURCES_REQUEST]: projectResourcesRequest,
  [Types.PROJECT_RESOURCES_SUCCESS]: projectResourcesSuccess,
  [Types.PROJECT_RESOURCES_FAILURE]: projectResourcesFailure,

  [Types.PROJECT_MEMBERS_REQUEST]: projectMembersRequest,
  [Types.PROJECT_MEMBERS_SUCCESS]: projectMembersSuccess,
  [Types.PROJECT_MEMBERS_FAILURE]: projectMembersFailure,

  [Types.JOIN_PROJECT_REQUEST]: joinProjectRequest,
  [Types.JOIN_PROJECT_SUCCESS]: joinProjectSuccess,
  [Types.JOIN_PROJECT_FAILURE]: joinProjectFailure,

  [Types.GET_JOIN_PROJECTS_REQUEST]: getJoinProjectsRequest,
  [Types.GET_JOIN_PROJECTS_SUCCESS]: getJoinProjectsSuccess,
  [Types.GET_JOIN_PROJECTS_FAILURE]: getJoinProjectsFailure,

  [Types.GET_USER_PROJECTS_REQUEST]: getUserProjectsRequest,
  [Types.GET_USER_PROJECTS_SUCCESS]: getUserProjectsSuccess,
  [Types.GET_USER_PROJECTS_FAILURE]: getUserProjectsFailure,

  [Types.CREATE_PROJECT_REQUEST]: createProjectRequest,
  [Types.CREATE_PROJECT_SUCCESS]: createProjectSuccess,
  [Types.CREATE_PROJECT_FAILURE]: createProjectFailure,

  [Types.GET_RESOURCES_REQUEST]: getResourcesRequest,
  [Types.GET_RESOURCES_SUCCESS]: getResourcesSuccess,
  [Types.GET_RESOURCES_FAILURE]: getResourcesFailure,

  [Types.ADD_RESOURCES_REQUEST]: addResourcesRequest,
  [Types.ADD_RESOURCES_SUCCESS]: addResourcesSuccess,
  [Types.ADD_RESOURCES_FAILURE]: addResourcesFailure,

  [Types.DELETE_PROJECT_REQUEST]: deleteProjectRequest,
  [Types.DELETE_PROJECT_SUCCESS]: deleteProjectSuccess,
  [Types.DELETE_PROJECT_FAILURE]: deleteProjectFailure,

  [Types.UPDATE_PROJECT_DETAILS_REQUEST]: updateProjectDetailsRequest,
  [Types.UPDATE_PROJECT_DETAILS_SUCCESS]: updateProjectDetailsSuccess,
  [Types.UPDATE_PROJECT_DETAILS_FAILURE]: updateProjectDetailsFailure,

  [Types.GET_COMMENTS_REQUEST]: getCommentsRequest,
  [Types.GET_COMMENTS_SUCCESS]: getCommentsSuccess,
  [Types.GET_COMMENTS_FAILURE]: getCommentsFailure,

  [Types.POST_COMMENT_REQUEST]: postCommentRequest,
  [Types.POST_COMMENT_SUCCESS]: postCommentSuccess,
  [Types.POST_COMMENT_FAILURE]: postCommentFailure,

  [Types.GET_PROJECT_IMAGES_REQUEST]: getProjectImagesRequest,
  [Types.GET_PROJECT_IMAGES_SUCCESS]: getProjectImagesSuccess,
  [Types.GET_PROJECT_IMAGES_FAILURE]: getProjectImagesFailure,

  [Types.ADD_PROJECT_IMAGE_REQUEST]: addProjectImageRequest,
  [Types.ADD_PROJECT_IMAGE_SUCCESS]: addProjectImageSuccess,
  [Types.ADD_PROJECT_IMAGE_FAILURE]: addProjectImageFailure,

  [Types.UPDATE_PROJECT_ICON_REQUEST]: updateProjectIconRequest,
  [Types.UPDATE_PROJECT_ICON_SUCCESS]: updateProjectIconSuccess,
  [Types.UPDATE_PROJECT_ICON_FAILURE]: updateProjectIconFailure,

  [Types.UPDATE_PROJECT_AVATAR_REQUEST]: updateProjectAvatarRequest,
  [Types.UPDATE_PROJECT_AVATAR_SUCCESS]: updateProjectAvatarSuccess,
  [Types.UPDATE_PROJECT_AVATAR_FAILURE]: updateProjectAvatarFailure,

  [Types.CREATE_PROJECT_UPDATE_REQUEST]: createProjectUpdateRequest,
  [Types.CREATE_PROJECT_UPDATE_SUCCESS]: createProjectUpdateSuccess,
  [Types.CREATE_PROJECT_UPDATE_FAILURE]: createProjectUpdateFailure,

  [Types.GET_PROJECT_UPDATES_REQUEST]: getProjectUpdatesRequest,
  [Types.GET_PROJECT_UPDATES_SUCCESS]: getProjectUpdatesSuccess,
  [Types.GET_PROJECT_UPDATES_FAILURE]: getProjectUpdatesFailure,

  [Types.DELETE_PROJECT_UPDATE_REQUEST]: deleteProjectUpdateRequest,
  [Types.DELETE_PROJECT_UPDATE_SUCCESS]: deleteProjectUpdateSuccess,
  [Types.DELETE_PROJECT_UPDATE_FAILURE]: deleteProjectUpdateFailure,

  [Types.DELETE_PROJECT_IMAGE_REQUEST]: deleteProjectImageRequest,
  [Types.DELETE_PROJECT_IMAGE_SUCCESS]: deleteProjectImageSuccess,
  [Types.DELETE_PROJECT_IMAGE_FAILURE]: deleteProjectImageFailure,

  [Types.SAVE_PROJECT_REQUEST]: saveProjectRequest,
  [Types.SAVE_PROJECT_SUCCESS]: saveProjectSuccess,
  [Types.SAVE_PROJECT_FAILURE]: saveProjectFailure,

  [Types.SUBMIT_RATING_REQUEST]: submitRatingRequest,
  [Types.SUBMIT_RATING_SUCCESS]: submitRatingSuccess,
  [Types.SUBMIT_RATING_FAILURE]: submitRatingFailure,
});

/* ------------- Selectors ------------- */

export const ProjectSelectors = {
  getFetching: state => state.projects.fetching,
  getErrors: state => state.projects.error,
  getUpdateFeed: state => state.projects.updateFeed,
  getUpdateDetail: state => state.projects.updateDetail,
  getExploreProjects: state => state.projects.exploreProjects,
  getProjectDetails: state => state.projects.projectDetail,
  getProjectLeader: state => state.projects.projectLeader,
  getProjectResources: state => state.projects.projectResources,
  getProjectMembers: state => state.projects.projectMembers,
  getProjectRequests: state => state.projects.projectJoinRequests,
  getUserProjects: state => state.projects.userProjects,
  getResources: state => state.projects.resources,
  getCreatedProject: state => state.projects.createdProject,
  getComments: state => state.projects.comments,
  getProjectImages: state => state.projects.projectImages,
  getProjectUpdates: state => state.projects.projectUpdates
};
